import { useState, useEffect } from "react";
import gsap from "gsap";
import PassageUI from "./PassageUI";
import Container from "../components/Container";
import Image from "../components/Image";

function PassageContainer() {
  const [description, setDescription] = useState(0);
  const passageCallouts = [
    {
      text: (
        <h1>
          {" "}
          <span className=" text-[#FF3452] text-3xl">
            FULLY AUTOMATED CRM SYSTEM
          </span>{" "}
          <br />
          TO GET ALL THE DATA FROM ALL OF THE SHIP IN THE GIVEN AREA!
        </h1>
      ),
    },
    {
      text: <h1 className=" text-3xl">WIDE VIEW OF REGIONAL ACTIVITIES</h1>,
    },
    {
      text: (
        <h1>
          <span className=" text-[#FF3452] text-2xl">
            ADVANCED OCEAN AND TERRESTRIAL
          </span>{" "}
          <br />
          SELF MONITORING AND SELF ENFORCING. <br />
          <br />
          <span className=" text-[#FF3452] text-2xl">
            LEVERAGING PROPRIETARY AI{" "}
          </span>{" "}
          <br />
          MULTIPLE DATA SOURCES, PATTERN WATCHING, AND AUTO-COMMUNICATIONS 24/7.{" "}
          <br />
          <br />
          <span className=" text-[#FF3452] text-2xl">PEACE OF MIND</span> <br />
          24/7 LIVE SMART MONITORING. <br />
          <br />{" "}
          <span className=" text-[#FF3452] text-2xl">
            PROACTIVE AND EMPOWERING
          </span>
        </h1>
      ),
    },
    {
      text: (
        <h1>
          <span className=" text-[#FF3452] text-3xl">
            EACH ZONING AND APPLICABLE PROTOCOLS
          </span>{" "}
          <br />
          PREVENTIVE COMMUNCATIONS, AND ACTIONS/NOTIFICATIONS PER ZONE
        </h1>
      ),
    },
    {
      text: (
        <>
          <h1 className=" text-3xl text-[#FF3452] uppercase">
            Near Real-Time A.I. Tracking of Activities:
          </h1>
          <ul className=" list-disc">
            <li>
              <h1>Non-permitted Vessels Permitted AND Status = OK</h1>
            </li>
            <li>
              <h1>Permitted: Status: Suspicious</h1>
            </li>
            <li>
              <h1>RED ALERT</h1>
            </li>
          </ul>
        </>
      ),
    },
    {
      text: (
        <h1>
          <span className=" text-[#FF3452] text-3xl">RED ALERT</span> <br />
          <ul className=" list-disc">
            <li>ZONE IN ON VESSEL HISTORY AND TRACKING</li>
            <li>A.I. Powered Suggested Suspicious Activity</li>
            <li>Optional Auto Settings or Manual Actions</li>
          </ul>
        </h1>
      ),
    },
    {
      text: (
        <h1>
          <span className="text-[#FF3452] text-3xl">
            SMART AI ANALYSIS OF ACTIVITIES
          </span>{" "}
          <br /> PATTERNS, EVENTS SUCH AS OIL SPILLS, ACCIDENT, UNAUTHORIZED
          ACTIVITIES, DISASTER. 24/7 ANALYSIS FOR AUTO-COMMUNICATIONS, AND
          CUSTOMIZABLE TRIGGER ACTIONS.
        </h1>
      ),
    },
    {
      text: (
        <h1>
          <span className="text-[#FF3452] text-3xl">
            {" "}
            INSTANT COMMUNICATION TO VESSEL:
          </span>{" "}
          <br />
          <ul></ul>
          <li className=" list-disc">
            HUMAN BOT AUTOMATED MESSAGING 24/7 WITH PREFERENCE SETTINGS (# OF
            WARNINGS, ETC.)
          </li>
          <li className=" list-disc">MANUAL BACK AND FORTH MESSAGING</li>
        </h1>
      ),
    },
    {
      text: (
        <h1>
          {" "}
          <span className=" text-[#FF3452] text-3xl">
            {" "}
            PENDING GOV POLICIES
          </span>{" "}
          <br />
          SOLUTIONS OF OPTIONS FOR FURTHER ACTIONS
        </h1>
      ),
    },
  ];

  useEffect(() => {
    const passageAnimation = gsap.timeline({
      scrollTrigger: {
        trigger: ".passage",
        start: "top",
        end: "+=20000",
        scrub: 1,
      },
    });
    //entrance
    passageAnimation
      .set(".right-cards", {
        width: "40%",
        height: "100%",
        autoAlpha: 1,
      })
      .set(
        ".map-card",
        {
          width: "60%",
          height: "100%",
          autoAlpha: 1,
        },
        "<"
      )
      .set(".vessel-info", {
        autoAlpha: 0,
      })
      .set(".message-card", {
        display: "none",
        autoAlpha: 0,
        width: "0%",
      })
      .from(".passage-container", {
        scale: 0,
        y: -500,
        duration: 5,
        autoAlpha: 1,
        onUpdate: function () {
          setDescription(1);
        },
      })
      .to(
        ".map-animation-container",
        {
          scale: 2,
        },
        "<"
      )
      .to(".passage-container", {
        x: "150px",
      })
      .from(".passage-container .perspective", {
        rotateX: "0deg",
        rotateY: "0deg",
        rotateZ: "0deg",
        duration: 5,
      })
      .from(".passage-container .container-3d", {
        translateZ: "0px",
        duration: 1,
        stagger: 1,
      })
      .from(".side-nav .card-3d", {
        translateZ: "0px",
        duration: 1,
        stagger: 1,
        each: 0.5,
      })
      .from(
        ".passage-nav .card-3d",
        {
          translateZ: "0px",
          duration: 1,
          stagger: 1,
          each: 0.5,
        },
        "<"
      )
      .from(".home-card .card-3d", {
        translateZ: "0px",
        duration: 1,
        stagger: 1,
        each: 0.5,
      })
      //callout animation
      .from(
        ".callout-container",
        {
          autoAlpha: 0,
          x: "0px",
          duration: 3,
        },
        "<"
      )
      .to(".callout-container", {
        x: "-40px",
        duration: 8,
      })
      .to(
        ".callout-container",
        {
          x: "-40px",
          duration: 15,
        },
        "<"
      )
      .to(".callout-container", {
        autoAlpha: 0,
        x: "-30px",
        duration: 3,
      })
      //entrance continuation
      .to(".home-card .card-3d", {
        translateZ: "0px",
        duration: 1,
        stagger: 1,
      })
      .to(".home-content", {
        autoAlpha: 0,
      })
      .to(".home-content", {
        width: "0%",
        height: "0%",
      })
      //crm entrance
      .to(".passage-container", {
        x: 250,
        duration: 5,
      })
      .to(
        ".passage-container .perspective",
        {
          rotateY: "-30deg",
          duration: 3,
        },
        "<"
      )
      .to(
        ".crm-card",
        {
          width: "100%",
          height: "100%",
          autoAlpha: 1,
          duration: 3,
          onUpdate: () => {
            setDescription(1);
          },
        },
        "<"
      )
      .to(".crm-card .card-3d", {
        translateZ: "40px",
        duration: 1,
        stagger: 1,
        onUpdate: () => {
          setDescription(0);
        },
      })
      .to(
        ".crm-cards",
        {
          x: "-40%",
          duration: 10,
        },
        "<"
      )
      //callout container
      .to(
        ".callout-container",
        {
          autoAlpha: 1,
          x: "-40px",
          duration: 3,
        },
        "<+=2"
      )
      .to(".callout-container", {
        x: "-40px",
        duration: 8,
      })
      .to(".callout-container", {
        x: "-40px",
        duration: 15,
      })
      .to(".callout-container", {
        autoAlpha: 0,
        x: "-30px",
        duration: 3,
      })
      //crm continuation
      .to(".crm-card .card-3d", {
        translateZ: "0px",
        duration: 1,
        stagger: 1,
        onUpdate: () => {
          setDescription(0);
        },
      })
      .to(".crm-card", {
        width: "100%",
        height: "100%",
        autoAlpha: 0,
        duration: 3,
        onUpdate: () => {
          setDescription(1);
        },
      })
      .to(".callouts", {
        right: 0,
        left: "auto",
      })
      .to(".passage-container", {
        x: -250,
        duration: 5,
      })
      .to(
        ".passage-container .perspective",
        {
          rotateY: "30deg",
          rotateZ: "-10deg",
          duration: 5,
        },
        "<+=2"
      )
      .to(
        ".crm-card",
        {
          width: "0%",
          height: "0%",
          autoAlpha: 0,
          duration: 3,
          onUpdate: () => {
            setDescription(1);
          },
        },
        "<"
      )
      //map1 entrance
      .to(
        ".map-animation-container",
        {
          scale: 2,
          top: "350px",
          duration: 5,
        },
        "<"
      )
      .to(".home-content", {
        width: "100%",
        height: "100%",
        duration: 5,
        autoAlpha: 1,
      })
      .to(
        ".map-card",
        {
          width: "60%",
          height: "100%",
          duration: 5,
        },
        "<"
      )
      .to(".right-cards", {
        width: "40%",
        height: "100%",
        duration: 5,
      })
      .to(".home-card .card-3d", {
        translateZ: "40px",
        duration: 1,
        stagger: 0.3,
      })
      .to(
        ".map-card",
        {
          width: "100%",
          height: "100%",
          duration: 5,
        },
        "<"
      )
      .to(
        ".right-cards",
        {
          width: "0%",
          heigt: "0%",
          autoAlpha: 0,
          duration: 5,
        },
        "<"
      )
      .to(
        ".map-animation-container",
        {
          scale: 1,
          top: 0,
          duration: 5,
          onUpdate: () => {
            setDescription(2);
          },
        },
        "<"
      )
      //callout animation
      .to(
        ".callout-container",
        {
          autoAlpha: 1,
          x: "40px",
          duration: 3,
        },
        "<"
      )
      .to(".callout-container", {
        x: "40px",
        duration: 8,
      })
      .to(
        ".callout-container",
        {
          x: "40px",
          duration: 15,
        },
        "<"
      )
      .to(".callout-container", {
        autoAlpha: 0,
        x: "30px",
        duration: 3,
      })
      //
      .to(".map-card", {
        width: "100%",
        height: "100%",
        duration: 10,
      })
      .to(".passage-container", {
        x: -250,
        duration: 5,
      })
      //whole ui
      .to(
        ".passage-container .perspective",
        {
          rotateY: "35deg",
          rotateZ: "-10deg",
          duration: 5,
        },
        "<+=2"
      )
      .to(
        ".right-cards",
        {
          width: "40%",
          height: "100%",
          autoAlpha: 1,
          duration: 5,
        },
        "<"
      )
      .to(
        ".map-card",
        {
          width: "60%",
          height: "100%",
          duration: 5,
        },
        "<"
      )
      .to(
        ".map-animation-container",
        {
          scale: 2,
          top: "350px",
          duration: 5,
        },
        "<"
      )
      .to(".map-animation-container", {
        scale: 2,
        top: "350px",
        duration: 5,
      })
      .to(".map-animation-container", {
        scale: 2,
        top: "350px",
        duration: 8,
      })
      .to(".callouts", {
        right: 0,
        left: "auto",
        onUpdate: () => {
          setDescription(3);
        },
      })
      //callout animation
      .to(
        ".callout-container",
        {
          autoAlpha: 1,
          x: "40px",
          duration: 3,
        },
        "<"
      )
      .to(".callout-container", {
        x: "40px",
        duration: 8,
      })
      .to(
        ".callout-container",
        {
          x: "40px",
          duration: 15,
        },
        "<"
      )
      .to(".callout-container", {
        autoAlpha: 0,
        x: "30px",
        duration: 3,
      })
      //
      .to(".passage-container", {
        x: 250,
        duration: 5,
      })
      .to(
        ".passage-container .perspective",
        {
          rotateY: "-35deg",
          rotateZ: "10deg",
          duration: 5,
        },
        "<+=2"
      )
      //stats
      .to(".map-card", {
        width: "0%",
        duration: 5,
      })
      .to(
        ".right-cards",
        {
          width: "100%",
          duration: 5,
        },
        "<"
      )
      .to(
        ".list-card",
        {
          autoAlpha: 0,
          duration: 3,
        },
        "<"
      )
      .to(
        ".list-card",
        {
          height: "0%",
          duration: 5,
        },
        "<"
      )
      .to(
        ".stats-card",
        {
          height: "100%",
          autoAlpha: 0,
          duration: 5,
        },
        "<"
      )
      .to(
        ".stats-static",
        {
          display: "block",
          autoAlpha: 1,
          duration: 5,
        },
        "<"
      )
      .to(".stats-static", {
        display: "block",
        autoAlpha: 1,
        duration: 10,
      })
      .to(".callouts", {
        right: "auto",
        left: 0,
        onUpdate: () => {
          setDescription(4);
        },
      })
      .to(
        ".callout-container",
        {
          autoAlpha: 1,
          x: "-40px",
          duration: 3,
        },
        "<"
      )
      .to(".callout-container", {
        x: "-40px",
        duration: 8,
      })
      .to(
        ".callout-container",
        {
          x: "-40px",
          duration: 15,
        },
        "<"
      )
      .to(".callout-container", {
        autoAlpha: 0,
        x: "-30px",
        duration: 3,
      })
      // map 2
      .to(".passage-container", {
        x: -250,
        duration: 8,
      })
      .to(
        ".passage-container .perspective",
        {
          rotateY: "35deg",
          rotateZ: "-10deg",
          duration: 8,
        },
        "<"
      )
      .to(".right-cards", {
        width: "40%",
        duration: 5,
      })
      .to(
        ".map-card",
        {
          width: "60%",
          duration: 5,
        },
        "<"
      )
      .to(
        ".stats-static",
        {
          autoAlpha: 0,
          duration: 5,
        },
        "<"
      )
      .to(
        ".stats-static",
        {
          display: "none",
        },
        "<"
      )
      .to(".list-card", {
        autoAlpha: 1,
        duration: 3,
      })
      .to(
        ".list-card",
        {
          height: "60%",
          duration: 5,
        },
        "<"
      )
      .to(
        ".stats-card",
        {
          height: "40%",
          duration: 5,
        },
        "<"
      )
      .to(".stats-card", {
        autoAlpha: 1,
        duration: 3,
      })
      .to(
        ".map-animation-container",
        {
          scale: 2,
          top: "350px",
          duration: 5,
        },
        "<"
      )
      .to(".home-content", {
        width: "100%",
        height: "100%",
        duration: 5,
        autoAlpha: 1,
      })
      .to(
        ".map-card",
        {
          width: "60%",
          height: "100%",
          duration: 5,
        },
        "<"
      )
      .to(".right-cards", {
        width: "40%",
        height: "100%",
        duration: 5,
      })
      .to(".home-card .card-3d", {
        translateZ: "40px",
        duration: 1,
        stagger: 0.3,
      })
      .to(
        ".map-card",
        {
          width: "100%",
          height: "100%",
          duration: 5,
        },
        "<"
      )
      .to(
        ".right-cards",
        {
          width: "0%",
          heigt: "0%",
          autoAlpha: 0,
          duration: 5,
        },
        "<"
      )
      .to(".map-animation2-container", {
        display: "block",
      })
      .to(".map-animation-container", {
        scale: 1,
        top: 0,
        duration: 5,
      })
      .to(".map-animation2-container", {
        scale: 1,
        duration: 5,
        autoAlpha: 1,
      })
      .to(".map-card", {
        width: "100%",
        height: "100%",
        duration: 10,
      })
      //callout animation
      .to(
        ".callouts",
        {
          left: "auto",
          right: 0,
          onUpdate: () => {
            setDescription(5);
          },
        },
        "<"
      )
      .to(
        ".callout-container",
        {
          autoAlpha: 1,
          x: "40px",
          duration: 3,
        },
        "<"
      )
      .to(".callout-container", {
        x: "40px",
        duration: 8,
      })
      .to(
        ".callout-container",
        {
          x: "40px",
          duration: 15,
        },
        "<"
      )
      .to(".callout-container", {
        autoAlpha: 0,
        x: "30px",
        duration: 3,
      })
      .to(".passage-container", {
        x: 250,
        duration: 8,
      })
      .to(
        ".passage-container .perspective",
        {
          rotateY: "-45deg",
          rotateZ: "10deg",
          duration: 8,
        },
        "<"
      )
      .to(".vessel-info", {
        autoAlpha: 1,
        duration: 5,
      })
      .from(".vessel-info .card-3d", {
        translateZ: "0",
        duration: 8,
      })
      .to(".vessel-info .card-3d", {
        translateZ: "40px",
        duration: 8,
      })
      //callout animation
      .to(".callouts", {
        left: 0,
        right: "auto",
        onUpdate: () => {
          setDescription(6);
        },
      })
      .to(
        ".callout-container",
        {
          autoAlpha: 1,
          x: "0px",
          duration: 3,
        },
        "<"
      )
      .to(".callout-container", {
        x: "-40px",
        duration: 8,
      })
      .to(
        ".callout-container",
        {
          x: "-40px",
          duration: 15,
        },
        "<"
      )
      .to(".callout-container", {
        autoAlpha: 0,
        x: "-30px",
        duration: 3,
      })
      .to(".passage-container", {
        x: 200,
        duration: 8,
      })
      .to(".vessel-info .card-3d", {
        translateZ: "0",
        duration: 8,
      })
      .to(".vessel-info", {
        autoAlpha: 0,
        duration: 5,
      })
      //message entrance
      .to(".message-card", {
        autoAlpha: 0,
        display: "block",
      })
      .to(".home-card .card-3d", {
        translateZ: "0px",
        duration: 1,
        stagger: 1,
      })
      .to(".home-content", {
        autoAlpha: 0,
      })
      .to(".home-content", {
        width: "0%",
        height: "0%",
      })
      .to(".passage-container", {
        x: -250,
        duration: 5,
      })
      .to(
        ".passage-container .perspective",
        {
          rotateY: "30deg",
          rotateZ: "-10deg",
          duration: 5,
        },
        "<"
      )
      .to(
        ".message-card",
        {
          width: "100%",
          height: "100%",
          autoAlpha: 1,
          duration: 3,
        },
        "<"
      )
      .from(".message-card .card-3d", {
        translateZ: "0px",
        duration: 5,
        stagger: 1,
      })
      //callout animation
      .to(
        ".callouts",
        {
          left: "auto",
          right: 0,
          onUpdate: () => {
            setDescription(7);
          },
        },
        "<"
      )
      .to(".callout-container", {
        autoAlpha: 1,
        x: "40px",
        duration: 3,
      })
      .to(".callout-container", {
        x: "40px",
        duration: 8,
      })
      .to(
        ".callout-container",
        {
          x: "40px",
          duration: 15,
        },
        "<"
      )
      .to(".callout-container", {
        autoAlpha: 0,
        x: "30px",
        duration: 3,
      })
      .to(".message-card .card-3d", {
        translateZ: "40px",
        duration: 10,
        stagger: 1,
      })
      .to(".message-card", {
        width: "100%",
        height: "100%",
        autoAlpha: 0,
        duration: 3,
      })
      .to(".message-card .card-3d", {
        translateZ: "0px",
        duration: 5,
        stagger: 1,
      })
      .to(
        ".message-card",
        {
          width: "0%",
          height: "0%",
          autoAlpha: 0,
          duration: 3,
        },
        "<"
      )
      .to(".passage-container", {
        x: 250,
        duration: 5,
      })
      .to(
        ".passage-container .perspective",
        {
          rotateY: "-30deg",
          rotateZ: "10deg",
          duration: 5,
        },
        "<"
      )
      .to(".drone-card", {
        autoAlpha: 0,
      })
      .to(".drone-card", {
        display: "flex",
      })
      .to(".drone-card", {
        autoAlpha: 1,
      })
      .from(".drone-card .card-3d", {
        translateZ: "0px",
      })
      //callout animation
      .to(
        ".callouts",
        {
          left: 0,
          right: "auto",
          onUpdate: () => {
            setDescription(8);
          },
        },
        "<"
      )
      .to(".callout-container", {
        autoAlpha: 1,
        x: "-40px",
        duration: 3,
      })
      .to(".callout-container", {
        x: "-40px",
        duration: 8,
      })
      .to(
        ".callout-container",
        {
          x: "-40px",
          duration: 15,
        },
        "<"
      )
      .to(".callout-container", {
        autoAlpha: 0,
        x: "-30px",
        duration: 3,
      })
      .to(".passage-container", {
        x: 0,
        duration: 5,
      })
      .to(
        ".passage-container .perspective",
        {
          rotateY: "0deg",
          rotateZ: "0deg",
          duration: 5,
        },
        "<"
      )
      .to(".passage-container", {
        scale: 0,
        y: 500,
        duration: 10,
        autoAlpha: 0,
      })
      .to(".passage-logo", {
        display: "flex",
      })
      .from(".passage-logo", {
        y: 500,
        duration: 10,
      });
  }, []);
  return (
    <>
      <div className="callouts absolute w-[50%] h-full flex justify-center items-center top-0 left-0 z-10">
        <div className="callout-container w-1/2">
          {passageCallouts[description].text}
        </div>
      </div>
      <div className="passage-logo h-full w-full absolute top-0 left-0 z-20 hidden justify-center items-center">
        <Image
          containerCss={" h-auto w-[300px]"}
          imgCss={"h-full w-full object-contain"}
          src={
            "https://res.cloudinary.com/dl5mqatis/image/upload/v1644224875/passage/passage_myfxm9.png"
          }
        />
      </div>
      <div className="passage-container w-full h-full flex justify-center align-middle scale-50">
        <Container innerContent={<PassageUI />}></Container>
      </div>
    </>
  );
}

export default PassageContainer;
